<template>
	<sf-modal-layout class="qms-xxl" :title="pwaApcnPopupInfo.title" :show="display" :closeModal="close">
		<div class="sf-actions">
			<div className="sf-actions__left">
				<template v-if="pwaApcnPopUp.btnApprAuth">
					<template v-if="pwaApcnPopUp.btnApprAuth2">
						<!--승인-->
						<sf-button size="sm" v-if="isButton_(scrId, 'CA')" line icon="round-check-on" :onClick="OpenApprPopup3">
							{{ getMessage_('QWCC001001') }}2
						</sf-button>
						<!--기각-->
						<sf-button size="sm" v-if="isButton_(scrId, 'RJ') && isButton_(scrId, 'CA')" line icon="circle-close" :onClick="OpenApprPopup1">
							{{ getMessage_('QWCC001002') }}
						</sf-button>

						<!--반려-->
						<sf-button size="sm" v-if="isButton_(scrId, 'GV') && isButton_(scrId, 'CA')" line icon="circle-close" :onClick="OpenApprPopup2">
							{{ getMessage_('QWCC001003') }}
						</sf-button>
					</template>
					<template v-else-if="!pwaApcnPopUp.btnApprAuth2">
						<!--승인-->
						<sf-button size="sm" v-if="isButton_(scrId, 'CS')" line icon="round-check-on" :onClick="OpenApprPopup3">
							{{ getMessage_('QWCC001001') }}1
						</sf-button>
						<!--기각-->
						<sf-button size="sm" v-if="isButton_(scrId, 'RJ') && isButton_(scrId, 'CS')" line icon="circle-close" :onClick="OpenApprPopup1">
							{{ getMessage_('QWCC001002') }}
						</sf-button>

						<!--반려-->
						<sf-button size="sm" v-if="isButton_(scrId, 'GV') && isButton_(scrId, 'CS')" line icon="circle-close" :onClick="OpenApprPopup2">
							{{ getMessage_('QWCC001003') }}
						</sf-button>
					</template>
				</template>

				<!--임시저장-->
				<sf-button size="sm" v-if="pwaApcnPopUp.btnTsAuth" line icon="file" :onClick="tmpSaveAction">
					{{ getMessage_('QWCC001004') }}
				</sf-button>
				<!--삭제-->
				<sf-button size="sm" v-if="pwaApcnPopUp.btnDelAuth" line icon="trash" color="error" :onClick="delAction">
					{{ getMessage_('MWCC000328') }}
				</sf-button>
				<!--신청-->
				<sf-button size="sm" v-if="pwaApcnPopUp.btnApAuth" line icon="round-check-on" :onClick="appSaveAction">
					{{ getMessage_('QWCC001005') }}
				</sf-button>

				<template v-if="pwaApcnPopUp.backBtnOnlyAuth">
						<sf-button size="sm" v-if="isButton_(scrId, 'GV') && isButton_(scrId, 'CS')" line icon="circle-close" :onClick="OpenApprPopup2">
							{{ getMessage_('QWCC001003') }}
						</sf-button>
				</template>
			</div>
		</div>

		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-20">
				<template v-if="!isLoading">
					<sf-card class="p-0 border-0 bg-transparent h-100">
						<pwa-apcn-popup-table-info1 ref="tableInfo1" :scrId="scrId"></pwa-apcn-popup-table-info1>
						<pwa-apcn-popup-table-info2
							ref="tableInfo2"
							:sendParam5="sendParam5"
							@OpenPmcPopup="OpenPmcPopup"
							:scrId="scrId"
						></pwa-apcn-popup-table-info2>
						<pwa-apcn-popup-table-info3
							ref="tableInfo3"
							:scrId="scrId"
							:sendParam1="sendParam1"
							@OpenDelPopup="OpenDelPopup"
							@ChangeStdCst="ChangeStdCst"
							:sendParam2="sendParam2"
							@OpenPopupCommCode="OpenPopupCommCode"
							:sendParam3="sendParam3"
							@OpenCauseCdPopupCommCode="OpenCauseCdPopupCommCode"
							:sendParam6="sendParam6"
							@OpenPopupPartNo="OpenPopupPartNo"
							@DelGridPartNo="DelGridPartNo"
						></pwa-apcn-popup-table-info3>
					<pwa-apcn-popup-table-info7 ref="tableInfo7" :scrId="scrId"></pwa-apcn-popup-table-info7>
						<pwa-apcn-popup-table-info4
							ref="tableInfo4"
							:scrId="scrId"
							:sendParam4="sendParam4"
							@OpenGridPartPopup="OpenGridPartPopup"
							@OpenDelCausePartNo="OpenDelCausePartNo"
							@ResetCauInfoReset="ResetCauInfoReset"
						></pwa-apcn-popup-table-info4>
						<pwa-apcn-popup-table-info5 ref="tableInfo5" :scrId="scrId"></pwa-apcn-popup-table-info5>
					<pwa-apcn-popup-table-info6 ref="tableInfo6" v-if="apprCommentList && apprCommentList.length > 0" :scrId="scrId"></pwa-apcn-popup-table-info6>
						<com-appr-rson-popup ref="apprRsonPop" :scrId="scrId"></com-appr-rson-popup>
						<!--딜러팝업-->
						<comp-popup ref="compPopup" @SendData="sendData1" @Refresh="Refresh" :scrId="scrId" />
						<!--공통팝업-->
						<com-cd-popup ref="comCdPopup" @SendData="sendData2" @Refresh="Refresh" :scrId="scrId" />
						<!--원인코드 공통팝업-->
						<com-cd-popup ref="comCdPopup1" @SendData="sendData6" @Refresh="Refresh" :scrId="scrId" />
						<!--원인부품팝업-->
						<as-part-popup ref="partPopup" @SendPartData="sendData3" @Refresh="Refresh" :scrId="scrId" />
						<!--원인부품팝업-->
						<as-part-popup ref="partGridPopup" @SendPartData="sendData4" @Refresh="Refresh" :scrId="scrId" />
						<!--PMC팝업-->
						<car-sale-popup ref="pmcNoPopup" @SendPmcData="sendData5" @Refresh="Refresh" :scrId="scrId" />
						<!--기각-->
						<com-appr-rson-popup ref="pmcApprRsonPopup" @apprRsonfresh="apprRsonfresh" :scrId="scrId" />
					</sf-card>
				</template>
			</div>
		</div>
	</sf-modal-layout>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

import * as Yup from 'yup';

import PwaApcnPopupTableInfo1 from './Table/PwaApcnPopupTableInfo1.vue';
import PwaApcnPopupTableInfo2 from './Table/PwaApcnPopupTableInfo2.vue';
import PwaApcnPopupTableInfo3 from './Table/PwaApcnPopupTableInfo3.vue';
import PwaApcnPopupTableInfo4 from './Table/PwaApcnPopupTableInfo4.vue';
import PwaApcnPopupTableInfo5 from './Table/PwaApcnPopupTableInfo5.vue';
import PwaApcnPopupTableInfo6 from './Table/PwaApcnPopupTableInfo6.vue';
import PwaApcnPopupTableInfo7 from './Table/PwaApcnPopupTableInfo7.vue';
import ComApprRsonPopup from '@qms/comm/commpopup/ComApprRsonPopup/ComApprRsonPopup.vue';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue'; // 딜러점팝업
import ComCdPopup from '@qms/comm/commpopup/ComCdPopup/ComCdPopup.vue'; //공통코드팝업
import AsPartPopup from '@qms/comm/commpopup/AsPartPopup/AsPartPopup.vue'; //원인부품팝업
import CarSalePopup from '@qms/comm/commpopup/CarSalePopup/CarSalePopup.vue'; //PMC팝업

import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import qmsUtils from '@/store/qms/api'; //변수관리 값 가져오기
import moment from 'moment';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		//해당 컴포넌트안에서 사용하는 상태 정의(지역변수)
		return {
			display: false,
			isLoading: false,
			stdCst: '',
			pwaApcnPopupInfo: {
				title: '', //타이틀명
				pwaNo: '', //Pwa번호
				fileList: []
			},
			sendParam1: {}, //딜러펍업
			sendParam2: {}, //공통팝업
			sendParam3: {}, //품번팝업
			sendParam4: {}, //품번팝업
			sendParam5: {}, //PMC팝업
			sendParam6: {} //원인코드팝업
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		schema() {
			return Yup.object().shape({
				tclgDgns: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001079')])), //{0}은(는) 팔수 입력 값 입니다. ,  기술진단
				custCplnSbc: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001078')])), //{0}은(는) 팔수 입력 값 입니다. ,  고객불만내용
				dtlSbc: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001080')])),
				//URL체크 ARRAY 형식이 아닌 단독으로 VALIDATION 체크
				/*
				dtc3: Yup.string()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001128')]))
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])), //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. dtc, //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				dtc2: Yup.string()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001128')]))
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])), //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. dtc, //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				dtc1: Yup.string()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001128')]))
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])), //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. dtc
					*/

				dtc3: Yup.string()
					.nullable()
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])),

				dtc2: Yup.string()
					.nullable()
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])),

				dtc1: Yup.string()
					.nullable()
					.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])),

				incdCst: Yup.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001103')])), ////{0}은(는) 팔수 입력 값 입니다. , 부대비
				//.matches(/^[0-9]*$/, this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001103')])),

				ctype: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001056')])), //{0}은(는) 팔수 입력 값 입니다. ,  Ctype
				phmnCd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001055')])), //{0}은(는) 팔수 입력 값 입니다. ,  현상코드
				causCd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001029')])), //{0}은(는) 팔수 입력 값 입니다. ,  원인코드
				dgnDd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001054')])), //{0}은(는) 팔수 입력 값 입니다. ,  진단일자
				milg: Yup.number() //주행거리
					.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC000972')]))
					.max(9999999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC000972'), '7'])) //{0}은 최대 {5} 자리까지 입력 가능합니다.
					.transform((_, val) => (val !== '' ? Number(val) : null)),

				causPartNo: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001028')])), //{0}은(는) 팔수 입력 값 입니다. ,  원인부품

				dtlRegn: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001051')])), //{0}은(는) 팔수 입력 값 입니다. ,  수리지역세부
				occuRegn: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001049')])), //{0}은(는) 팔수 입력 값 입니다. ,  수리지역
				rprRegn: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001050')])), //{0}은(는) 팔수 입력 값 입니다. ,  발생지역

				dlrCpnyCd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000959')])),
				pmcId: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001538')])) //{0}은(는) 팔수 입력 값 입니다. , PMCID
			});
		},
		schemaImsi() {
			return Yup.object().shape({
				//URL체크 ARRAY 형식이 아닌 단독으로 VALIDATION 체크
				dtc3: Yup.string().matches(
					/^[A-Za-z0-9]*$/,
					this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])
				), //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. dtc, //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				dtc2: Yup.string().matches(
					/^[A-Za-z0-9]*$/,
					this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])
				), //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. dtc, //{0}은(는) 팔수 입력 값 입니다. ,  DTC
				dtc1: Yup.string().matches(
					/^[A-Za-z0-9]*$/,
					this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001128')])
				), //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. dtc
				milg: Yup.string().matches(/^[0-9]*$/, this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC000972')])) //주행거리는 숫자만 입력 가능합니다.
			});
		},
		schemaRecord() {
			return Yup.array().of(
				Yup.object().shape({
					partCst: Yup.number()
						.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001040')])) //{0}은(는) 숫자만 입력 가능합니다. , 부품가격
						.positive(this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('QWCC001040')])) //{0}은(는) 양수만 입력 가능합니다. , 부품가격
						.min(1, this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC001040'), '0'])) //{0}은 최소 {0} 초과하여 입력 해야합니다.
						.max(9999999999999, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('QWCC001040'), '13'])) //{0}은 최대 {5} 자리까지 입력 가능합니다.
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001040')])), ////{0}은(는) 팔수 입력 값 입니다.

					qty: Yup.string()
						.nullable()
						//.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC000977')])) //{0}은(는) 숫자만 입력 가능합니다. ,  교환부품수량
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000977')])), ////{0}은(는) 팔수 입력 값 입니다. , 교환부품수량

					partNo: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001037')])), //{0}은(는) 팔수 입력 값 입니다. , 품번

					lts: Yup.string()
						.trim()
						.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001100')]))
						.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001100')])) // 은 필수 입력 항목입니다. , lts
						.matches(/^[.0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC000068'), [this.getMessage_('QWCC001100')])) //숫자만 입력가능합니다
				})
			);
		},
		schemaRecordImsi() {
			return Yup.array().of(
				Yup.object().shape({
					/*
					qty: Yup.string()
						.nullable()
						//.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC000977')])) //{0}은(는) 숫자만 입력 가능합니다. ,  교환부품수량
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000977')])), ////{0}은(는) 팔수 입력 값 입니다. , 교환부품수량
					*/
					partNo: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001037')])) //{0}은(는) 팔수 입력 값 입니다. , 품번
				})
			);
		},
	
	},
	components: {
		PwaApcnPopupTableInfo1,
		PwaApcnPopupTableInfo2,
		PwaApcnPopupTableInfo3,
		PwaApcnPopupTableInfo4,
		PwaApcnPopupTableInfo5,
		PwaApcnPopupTableInfo6,
		PwaApcnPopupTableInfo7,
		ComApprRsonPopup /*기각사유 */,
		CompPopup /*딜러점팝업*/,
		ComCdPopup /*공통팝업*/,
		AsPartPopup /*AS부품팝업*/,
		//PartPopup /*부품팝업*/,
		CarSalePopup /*PMC팝업*/
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		Refresh() {},
		apprRsonfresh() {
			this.close();
			this.$emit('Refresh');
		},
		async open(param) {
			this.display = true;
			this.isLoading = true;
			this.$sf_toggleLoading(true);

			this.pwaApcnPopupInfo.title = param.title;
			this.pwaApcnPopupInfo.pwaNo = param.pwaNo;
			let paramPwaNo = this.pwaApcnPopupInfo.pwaNo;
			this.pwaApcnPopupInfo.prcsRslt = param.prcsRslt;
			let prcsRslt = this.pwaApcnPopupInfo.prcsRslt;

			
			const ssClassValue = await qmsUtils.getVariableValue(this.user.deptCd);
			let ssClass = ssClassValue ? ssClassValue.varVal : '';
			//작업내용 기준금액 가져오기(변수관리에 등록되어있음)
			const rsltVarValue = await qmsUtils.getVariableValue('pwaEndPartStdCst'+ssClass);

			//원인부품 코드에서 그리드로 추가될때 기준금액 셋팅함
			this.stdCst = rsltVarValue.varVal;

			//초기화
			this.setStateApcnInit_();

			//console.log('가>>>>>', this.pwaApcnPopUp.pwaEndPartStdCst);
			//this.setStatePwaApcnState_({ key: 'pwaEndPartStdCst', value: rsltVarValue.varVal }); //조건
			//console.log('나>>>.>>', this.pwaApcnPopUp.pwaEndPartStdCst);

			try {
				
				if (paramPwaNo) {
					const pwaNoParam = {
						pwaNo: paramPwaNo,
						paramState: '',
						prcRsltCd: prcsRslt
					};

					//console.log('상세조회시작  문서번호>>>', paramPwaNo);

					await this.getPwaApcnPopList_(pwaNoParam);

					//임시저장권한
					await this.setBtnTsAuth_(this.isButton_(this.scrId, 'TS'));

					//신청권한
					await this.setBtnApAuth_(this.isButton_(this.scrId, 'AP'));

					//삭제권한
					await this.setBtnDelAuth_(this.isButton_(this.scrId, 'CD'));

					//승인권한
					await this.setBtnApprAuth_();
				} else {
					//console.log('PWA번호등록');
					//임시저장권한
					await this.setBtnTsAuth_(this.isButton_(this.scrId, 'TS'));
					//신청권한
					await this.setBtnApAuth_(this.isButton_(this.scrId, 'AP'));
					//삭제권한
					await this.setBtnDelAuth_(this.isButton_(this.scrId, 'CD'));
					
					//승인권한
					await this.setBtnApprAuth_();
				}

				
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.isLoading = false;
				this.$sf_toggleLoading(false);
			}

			//조회
		},
		ResetCauInfoReset(param) {
			//console.log(param);
			this.$refs.tableInfo3.causePartInfoBeforeDataSet(param);
		},
		close() {
			this.isLoading = true;
			this.display = false;
		},
		makeValidate() {
			const tmpMilg = Number(convertNvl(this.savePwaApcn.milg, '0')); //주행거리

			const tmptmpMilg = Number(convertNvl(this.savePwaApcn.milgPo + '0000', '0')); //보증주행거리 150000

			const tmpUsePrd = Number(convertNvl(this.savePwaApcn.usePrd, '0')); //사용기간

			const tmpUsePrdPo = Number(convertNvl(this.savePwaApcn.usePrdPo, '0')); //보증사용기간

			//console.log('>>>>>>', tmpMilg);
			//console.log('>>>>>>', tmptmpMilg);

			//console.log('>>>>>>사용기간', tmpUsePrd);
			//console.log('>>>>>>보증사용기간', tmpUsePrdPo);
			const oemSaleDd = convertNvl(this.savePwaApcn.oemSaleDd,null); 
			//사용기간이 보증기간보다 클경우
			if(oemSaleDd!=null){
				if (tmpUsePrd > tmpUsePrdPo) {
					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001891'))); // 보증수리 기간이 아닙니다. 데이터를 확인해주세요.'
				}

				//주행거리가 보증사용거리
				if (tmpMilg > tmptmpMilg) {
					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001892'))); //'보증 주행거리를 초과하였습니다. 데이터를 확인해주세요.'
				}
			}
		},
		OpenDelPopup(param) {
			//console.log('딜러점 에서의 cmpnCd 값 ::::: ', param.cmpnCd);

			this.$refs.compPopup.open(param); //.open(param);
		},
		OpenPopupCommCode(param) {
			//현상코드팝업
			//console.log('공통팝업 에서의 param 값 ::::: ', param);

			this.$refs.comCdPopup.open(param); //.open(param);
		},
		OpenCauseCdPopupCommCode(param) {
			//원인부품코드팝업
			//console.log('공통팝업 에서의 param 값 ::::: ', param);

			this.$refs.comCdPopup1.open(param); //.open(param);
		},
		OpenPopupPartNo(param) {
			//console.log('원인부품팝업 에서의 param 값 ::::: ', param);

			this.$refs.partPopup.open(param); //.open(param);
		},
		OpenGridPartPopup(param) {
			//console.log('교환부품 그리드 팝업 에서의 param 값 ::::: ', param);

			this.$refs.partGridPopup.open(param); //.open(param);
		},
		OpenDelCausePartNo() {
			//부품번호 삭제
			//console.log('교환부품 그리드 팝업 에서의 param 값 ::::: ', param);

			this.$refs.tableInfo3.delCausePartNo(); //.open(param);
		},
		OpenPmcPopup(param) {
			//console.log('차량정보에서 PMC팝업 에서의 param 값 ::::: ', param);

			this.$refs.pmcNoPopup.open(param); //.open(param);
		},
		OpenApprPopup1() {
			//이메일 제목 셋팅
			this.setStatePwaApcnState_({
				key: 'eMailtitle',
				value:
					this.$sf_formatString(this.getMessage_('QWCC001796'), [this.pwaApcnPopUp.pwaNo]) + '\n' + this.getMessage_('QWCC001145') + ':' //딜러점 {}에서 신청하신 PWA No 기각 되었습니다 기각사유:
			});

			//이메일 내용 셋팅
			this.setStatePwaApcnState_({
				key: 'eMailContents',
				value:
					this.$sf_formatString(this.getMessage_('QWCC001796'), [this.pwaApcnPopUp.pwaNo]) + '\n' + this.getMessage_('QWCC001145') + ':' //딜러점 {}에서 신청하신 PWA No 기각 되었습니다 기각사유:
			});

			/*기각*/
			let paramList = {
				apprState: 'G', //기각
				btnMsg: this.getMessage_('QWCC001002'), //기각
				labelMsg: this.getMessage_('QWCC001145'), //기각
				title: this.getMessage_('QWCC001145'), //기각사유
				cfMsg: this.getMessage_('QWCC001149'), //기각하시겠습니까?
				apiType: 'PWA',
				masterKey1: this.pwaApcnPopupInfo.pwaNo, //pwa번호
				masterKey2: this.pwaApcnPopUp.aplcId, //신청자Id
				masterKey3: this.pwaApcnPopUp.eMailtitle, //이메일 제목,
				masterKey4: this.pwaApcnPopUp.eMailContents //이메일 내용
			};

			this.$refs.pmcApprRsonPopup.open(paramList); //.open(param);
		},
		OpenApprPopup2() {
			//이메일 제목 셋팅
			this.setStatePwaApcnState_({
				key: 'eMailtitle',
				value:
					this.$sf_formatString(this.getMessage_('QWCC001797'), [this.pwaApcnPopUp.pwaNo]) + '\n' + this.getMessage_('QWCC001146') + ':' //신청하신 PWA No 반려 되었습니다 반려사유:
			});

			//이메일 내용 셋팅
			this.setStatePwaApcnState_({
				key: 'eMailContents',
				value:
					this.$sf_formatString(this.getMessage_('QWCC001797'), [this.pwaApcnPopUp.pwaNo]) + '\n' + this.getMessage_('QWCC001146') + ':' //신청하신 PWA No 반려 되었습니다 반려사유:
			});

			/*반려*/
			let paramList = {
				apprState: 'R', //반려
				btnMsg: this.getMessage_('QWCC001003'), //반려
				labelMsg: this.getMessage_('QWCC001146'), //반려
				title: this.getMessage_('QWCC001146'), //반려사유
				cfMsg: this.getMessage_('QWCC001150'), //반려하시겠습니까>?
				apiType: 'PWA',
				masterKey1: this.pwaApcnPopupInfo.pwaNo,
				masterKey2: this.pwaApcnPopUp.aplcId, //신청자Id
				masterKey3: this.pwaApcnPopUp.eMailtitle, //이메일 제목,
				masterKey4: this.pwaApcnPopUp.eMailContents //이메일 내용
			};

			this.$refs.pmcApprRsonPopup.open(paramList); //.open(param);
		},

		OpenApprPopup3() {
			//이메일 제목 셋팅
			this.setStatePwaApcnState_({
				key: 'eMailtitle',
				value: this.$sf_formatString(this.getMessage_('QWCC001790'), [this.pwaApcnPopUp.pwaNo])
			});
			//이메일 내용 셋팅
			this.setStatePwaApcnState_({
				key: 'eMailContents',
				value: this.$sf_formatString(this.getMessage_('QWCC001790'), [this.pwaApcnPopUp.pwaNo])
			});

			/*承认*/
			let paramList = {
				apprState: 'A',
				btnMsg: this.getMessage_('QWCC001001'),
				labelMsg: this.getMessage_('MWPE000025'),
				title: this.getMessage_('QWCC001001'),
				cfMsg: this.getMessage_('QWCC001155'),
				apiType: 'PWA',
				notScheme: true,
				masterKey1: this.pwaApcnPopupInfo.pwaNo,
				customSaveFn: contents => {
					this.setStatePwaApcnState_({ key: 'apprContents', value: contents });
					this.apprDupCnt();
				}
			};

			this.$refs.pmcApprRsonPopup.open(paramList); //.open(param);
		},
		
		sendData1(param) {
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			//console.log('result1', param);

			this.sendParam1 = param; //watch감시용
		},
		sendData2(param) {
			//console.log('result2', param);
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			this.sendParam2 = param; //watch감시용
		},
		sendData3(param) {
			//pwa 기초정보 원인부품팝업전용
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			if (param.asCst == 0) {
				param.zeroGb = true;
			} else {
				param.zeroGb = false;
			}
			if (param.lts == 0) {
				param.ltsZeroGb = true;
			} else {
				param.ltsZeroGb = false;
			}

			param.stdCst = this.stdCst; //기준금액 셋팅함

			this.$refs.tableInfo4.addPartInoGirdAction(param);

			this.sendParam3 = param; //watch감시용
		},
		sendData4(param) {
			//교환부품정보 END품팝업
			//console.log('result4', param);
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			param.stdCst = this.stdCst; //기준금액 셋팅함
			this.$refs.tableInfo4.gridParNoPopUp(param);

			this.sendParam4 = param; //watch감시용
		},
		sendData6(param) {
			//console.log('원인부품팝업', param);
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			this.sendParam6 = param; //watch감시용
		},
		ChangeStdCst(value){
			// console.log('stdCst', value);
			if (value !== undefined && value !== '') {
				this.stdCst = value;
				
				const selectedMaps = this.pwaApcnSwapPartsList.slice();
				// console.log('selectedMaps', selectedMaps);
				const mapData = {};

				selectedMaps.forEach((mapData, index) => {
					// console.log('2>>>>', selectedMaps[index]);
					
					selectedMaps[index].stdCst = this.stdCst;
					selectedMaps[index].wags = Math.round(selectedMaps[index].lts * this.stdCst * 100) / 100;
				});
			}
		},
		async sendData5(param) {
			//제품번호 팝업 내려올때 사용기간도 같이 조회해서 셋팅한다.
			//pmc번호전용

			//console.log('result5', param);

			let paramList = {
				oemSaleD: moment(param.oemSaleDd).format('YYYYMMDD'), //OEM판매일자.
				dgnDd: convertNvl(this.pwaApcnPopUp.dgnDd, '') == '' ? moment().format('YYYYMMDD') : this.pwaApcnPopUp.dgnDd //진단일자
			};

			//사용기간(년)
			await this.getPwaUsedYear_(paramList);

			//사용기간(년)셋팅
			this.$refs.tableInfo3.setUsedYearProcessInfo();

			this.sendParam5 = param; //watch감시용
		},
		async afterSaveClose() {
			//팝업창 닫고 재조회
			this.$sf_toggleLoading(true);
			this.close();
			this.$emit('Refresh');
		},
		async tmpSaveAction() {
			//임시저장
			await this.setState_({ key: 'isSaveFlag', value: true });

			try {
				// 임시저장시 유효성검사 로직 체크
				// 유효성 검사
				await this.schemaImsi.validateSync(this.savePwaApcn);

				//this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001128')])

				//if (this.pwaApcnSwapPartsList.length === 0) {
				//	this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001129') });
				//	return;
				//}

				//교환 부품정보 등록 체크된 녀석만 validation 진행함.
				//let pwaApcnChekdList = this.$refs.tableInfo4.gridCheckRowData();

				await this.schemaRecordImsi.validateSync(this.pwaApcnSwapPartsList);

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001157'), //임시저장하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001004'), clickFn: () => this.save('10') }], //임시저장,
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaveFlag', value: false });
			}
		},
		async appSaveAction() {
			//신청
			await this.setState_({ key: 'isSaveFlag', value: true });

			try {
				// 유효성 검사
				//PMC번호 입력여부
				await this.schema.validateSync(this.savePwaApcn);

				await this.makeValidate();

				//교환부품정보 등록이 되어있나
				if (this.pwaApcnSwapPartsList.length === 0) {
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001129') });
					return;
				}
				const oemSaleDd = convertNvl(this.savePwaApcn.oemSaleDd,null); 
				const milg = convertNvl(this.savePwaApcn.milg,null); 
				
				if(oemSaleDd!=null && milg==0){
					this.$sf_toast({ type: 'error', message: this.$sf_formatString(this.getMessage_('QWCC001077'), [this.getMessage_('QWCC000972'), '0']) });
					return;
				}

				//교환 부품정보 등록 체크된 녀석만 validation 진행함.
				//let pwaApcnChekdList = this.$refs.tableInfo4.gridCheckRowData();
				let pwaApcnChekdList = this.$refs.tableInfo4.gridCheckRowData();

				if (!this.$refs.tableInfo3.validate()) {
					return;
				}

				if (!this.$refs.tableInfo7.validate()) {
					return;
				}

				await this.schemaRecord.validateSync(this.pwaApcnSwapPartsList);

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001152'), //신청하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001005'), clickFn: () => this.save('20') }], //신청,
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaveFlag', value: false });
			}
		},
		async apprSaveAction() {
			//승인처리
			await this.setState_({ key: 'isSaveFlag', value: true });

			try {
				/*
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001155'), //승인하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001001'), clickFn: () => this.apprSave() }], //승인,
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
				*/

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001155'), //승인하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001001'), clickFn: () => this.apprDupCnt() }], //승인,
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaveFlag', value: false });
			}
		},
		async delAction() {
			//삭제
			await this.setState_({ key: 'isSaveFlag', value: true });

			/*삭제파람*/
			const delParam = {
				pwaNo: this.savePwaApcn.pwaNo,
				fileId: convertNvl(this.savePwaApcn.fileId, '')
			};

			try {
				//교환 부품정보 등록 체크된 녀석만 validation 진행함.
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000328'), clickFn: () => this.delete(delParam) }], //삭제
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaveFlag', value: false });
			}
		},
		async save(paramState) {
			//저장
			let formData = new FormData();

			//State를 formData에 Key Value로 넣습니다.
			//폼객체에 API 구분값을 담는다.
			Object.keys(this.savePwaApcn).forEach(key => formData.append(key, convertNvl(this.savePwaApcn[key], '')));

			//첨부파일 fileList로 바뀜
			if (this.savePwaApcn.fileList.length > 0) this.savePwaApcn.fileList.forEach(element => formData.append('fileList', element));
			else formData.append('fileList', '');

			/*fromData 찍어보기
			var object = {};
			formData.forEach((value, key) => (object[key] = value));
			var json = JSON.stringify(object);

			//console.log('formData>>>>>>>>>>', json);
			*/
			//return false;

			//교환부품
			//다돌리는거
			if (this.pwaApcnSwapPartsList.length > 0) {
				this.pwaApcnSwapPartsList.forEach((element, index) => {
					Object.keys(element).forEach(key => {
						formData.append('partList[' + index + '].' + key, element[key]);
					});
				});
			} else {
				formData.append('partList', '');
			}

			// 기타비용명세
			if (this.otherFeeList && this.otherFeeList.length > 0) {
				this.otherFeeList.forEach((element, index) => {
					Object.keys(element).filter(k => k !== 'no').forEach(key => {
						if(element[key]){
							formData.append('otherFeeList[' + index + '].' + key, element[key]);
						}
					});
				});
			} else {
				formData.append('otherFeeList', '');
			}

			//교환부품 체크로 선택한 데이터만 가지고 온다.
			/*
			let pwaApcnChekdList = this.$refs.tableInfo4.gridCheckRowData();

			//console.log('pwaApcnChekdList', pwaApcnChekdList);

			//교환부품셋팅
			if (pwaApcnChekdList.length > 0) {
				pwaApcnChekdList.forEach((element, index) => {
					Object.keys(element).forEach(key => {
						formData.append('partList[' + index + '].' + key, element[key]);
					});
				});
			} else {
				formData.append('partList', '');
			}
			*/

			//paramState값은 10은 임시저장, 20번 신청
			formData.append('state', paramState);

			//신청으로 들어올경우 이메일 제목 내용을 가져옴
			//if (paramState == '20') {
			//formData.append('eMailtitle', this.getMessage_('QWCC001728'));
			//formData.append('eMailContents', this.getMessage_('QWCC001728'));
			//}

			await this.savePwaApcnPopup_({ formData })
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}

					//임시저장후
					//재조회를 한후 처리상태 컴포넌트에 pwaNo. 처리단계 신청일 확정일등을
					//임시저장상태
					if (paramState === '10') {
						//alert('값이뭐냐' + response.body.pwaNo);

						const pwaNoParam = {
							pwaNo: response.body.pwaNo,
							paramState
						};

						this.getPwaApcnPopList_(pwaNoParam).then(response => {
							//다시 셋팅함.
							this.$refs.tableInfo1.setProcessInfo();
							this.$refs.tableInfo2.setProcessInfo();
							this.$refs.tableInfo3.setProcessInfo();
							this.$refs.tableInfo5.setProcessInfo();
							this.$refs.tableInfo7.setProcessInfo();
						});

						this.$emit('Refresh');
					} else {
						//모달창 닫고 재조회
						this.afterSaveClose();
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		async apprSave() {
			//이메일 제목 셋팅
			this.setStatePwaApcnState_({
				key: 'eMailtitle',
				value: this.$sf_formatString(this.getMessage_('QWCC001790'), [this.pwaApcnPopUp.pwaNo]) //신청하신 PWA No 승인되었습니다. 빠른 시일 내 클레임 입력 및 신청 바랍니다.
			});

			//이메일 내용 셋팅
			this.setStatePwaApcnState_({
				key: 'eMailContents',
				value: this.$sf_formatString(this.getMessage_('QWCC001790'), [this.pwaApcnPopUp.pwaNo]) //신청하신 PWA No 승인되었습니다. 빠른 시일 내 클레임 입력 및 신청 바랍니다.
			});

			this.setStatePwaApcnState_({
				key: 'prcsRslt',
				value: this.pwaApcnPopUp.prcsRslt 
			});

			this.setStatePwaApcnState_({
				key: 'prcsStep',
				value: this.pwaApcnPopUp.prcsStep 
			});

			//승인처리
			await this.saveStateAppr_()
				.then(response => {
					//console.log('승인완료후>>>>', response);

					if (response.header.code === 0 || response.header.code === 3) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});

						//모달창 닫고 재조회 정상일경우
						if (response.header.code === 0) {
							this.afterSaveClose();
						}
					} else if (response.header.code == 5) {
						this.afterSaveClose();
						throw new Error(this.getMessage_(response.header.messageCd));
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		async apprDupCnt() {
			//승인처리
			await this.apprDupCnt_()
				.then(response => {
					//console.log('>>>>>>>>>>', response);

					if (response.body.confirmYn == 'N') {
						if (response.header.message != undefined && response.header.message != null) {
							if (response.header.code === 0) {
								//승인처리한다.
								this.apprSave();
							} else {
								this.$sf_toast({
									type: response.header.code === 0 ? 'ok' : 'error',
									message: this.getMessage_(response.header.messageCd)
								});
							}
						}
					} else {
						this.$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: this.getMessage_(response.header.messageCd), //진행하시겠습니까?
							buttons: [{ title: this.getMessage_('SWCC000560'), clickFn: () => this.apprSave() }], //확인,
							closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
						});
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		async delete(delParam) {
			//console.log('delParam>>>', delParam);

			await this.deletePwaApcnPopup_(delParam)
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}

					//모달창 닫고 재조회
					this.afterSaveClose();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		DelGridPartNo(partNo) {
			//원인부품에서 품번을 지우면 END품번에 등록되어있는 품번을 지운다.

			let paramList = {
				partNo: partNo //품번
			};

			const paramArray = [paramList];

			this.$refs.tableInfo4.deletePartGridAction(paramArray);
		}
	},
	created() {
		console.clear();
			
	},
	watch: {
		pwaEndPartStdCst(newValue, oldValue) {
			//console.log('>>>>>>>>>>>>>>', newValue);
			//console.log('<>.<<<<<<<<', oldValue);
		}
	}
};
</script>

<style></style>
